import React from "react";
import Plan from "./components/Plan";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Plan></Plan>
    </div>
  );
}

export default App;
